import { atom } from 'jotai';

export const consumptionDetailModalOpenAtom = atom(false);
consumptionDetailModalOpenAtom.debugLabel = 'consumptionDetailModalOpenAtom';
